export const environment = {
  production: false,
  env: "Testing",
  apiUrl: 'https://gcidcapitest.clavisco.com/api/',
  recaptchaSiteKey: '6Le4V6QrAAAAAClRqFhv37b_LK8ZFdM325HZPeiz',
  logRocketId: ''
};
